export const MinimalColourPicker = ({
  categoryColour,
  setCategoryColour,
}: {
  categoryColour: string
  setCategoryColour: (color: string) => void
}) => {
  const presetColors: string[] = [
    '#ef4444',
    '#f97316',
    '#f59e0b',
    '#eab308',
    '#84cc16',
    '#22c55e',
    '#10b981',
    '#14b8a6',
    '#06b6d4',
    '#0ea5e9',
    '#3b82f6',
    '#6366f1',
    '#8b5cf6',
    '#a855f7',
    '#d946ef',
    '#ec4899',
    '#f43f5e',
    '#64748b',
  ]

  return (
    <div className="flex flex-wrap gap-2">
      {presetColors.map((hex) => {
        const isSelected = categoryColour === hex
        return (
          <button
            key={hex}
            type="button"
            onClick={() => setCategoryColour(hex)}
            className={`size-7 cursor-pointer rounded-full border transition focus:outline-none ${
              isSelected
                ? 'ring-2 ring-offset-2 border-transparent ring-gray-300 ring-offset-white dark:ring-white/60 dark:ring-offset-gray-900'
                : 'border-gray-300'
            }`}
            style={{ backgroundColor: hex }}
            aria-label={`Choose ${hex}`}
            title={hex}
          />
        )
      })}
    </div>
  )
}

export default MinimalColourPicker
